(() => {
  if (window.kmCartThumbnailsInitialized) return;
  window.kmCartThumbnailsInitialized = true;

  // PitchPrint's cart adapter matches images by array position. A drawer and
  // a cart page can contain two copies of a line, so let this theme own images.
  // Configure its supported selector before the app's header script loads.
  window.PPCLIENT = {
    ...window.PPCLIENT,
    customCartImageSel: '[data-km-pitchprint-vendor-image]',
  };

  const parseProject = value => {
    if (value && typeof value === 'object') return value;
    if (typeof value !== 'string') return null;
    try { return JSON.parse(value); } catch {}
    try { return JSON.parse(decodeURIComponent(value)); } catch { return null; }
  };

  const update = () => {
    let projects;
    try {
      projects = JSON.parse(localStorage.getItem('pprint-projects') || '{}');
    } catch { return; }
    if (!projects || typeof projects !== 'object') return;

    document.querySelectorAll('[data-km-pitchprint-project]').forEach(row => {
      const projectId = row.dataset.kmPitchprintProject;
      // Native customizer variants already have their own per-design image.
      if (!projectId || row.dataset.kmCustomizerDesign) return;
      // Merely opening a product restores a cached _pitchprint project ID.
      // Actual saves also attach a production-output property to the line.
      if (row.dataset.kmPitchprintOutput !== 'true') return;
      if (row.dataset.kmPitchprintFailed === projectId) return;
      if (!/^[a-zA-Z0-9_-]+$/.test(projectId)) return;
      const project = parseProject(projects[projectId]);
      if (!project || project.type === 'u') return;
      if (String(project.projectId) !== projectId) return;
      if (String(project.product?.id) !== row.dataset.kmProductId) return;

      const link = row.querySelector('[data-km-cart-preview]');
      const image = link?.querySelector('img');
      if (!image) return;
      const source = `https://s3-eu-west-1.amazonaws.com/pitchprint.io/previews/${projectId}_1.jpg`;
      if (image.getAttribute('src') === source) return;
      const original = {
        src: image.getAttribute('src'),
        srcset: image.getAttribute('srcset'),
        href: link.getAttribute('href'),
      };
      image.addEventListener('error', () => {
        row.dataset.kmPitchprintFailed = projectId;
        image.setAttribute('src', original.src);
        if (original.srcset) image.setAttribute('srcset', original.srcset);
        link.setAttribute('href', original.href);
      }, { once: true });
      image.removeAttribute('srcset');
      image.setAttribute('src', source);
      link.setAttribute('href', source);
    });
  };

  const start = () => {
    update();
    // Cart sections are replaced after adding, removing, or changing quantity.
    new MutationObserver(records => {
      if (records.some(record => record.addedNodes.length)) update();
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else start();
  window.addEventListener('storage', event => {
    if (event.key === 'pprint-projects') update();
  });
})();
